import { trackingMenu } from "./service/trakingMenu"

document.addEventListener('DOMContentLoaded', ()=>{
  trackingMenu.init();
})
